import React from 'react';
import styles from './ModalActionCellRenderer.module.scss';
import { CellRendererProps } from '../../../DataTable.types';
export const ModalActionCellRenderer: React.FC<CellRendererProps> = ({ row, column, dynamicProps }) => {
    const {
        handleModalActionClick,

        statusLabel: dynamicLabel,
        textColor: dynamicTextColor,
        hoverBgColor: dynamicHoverBgColor,
        iconFill: dynamicIconFill,
        hoverFill: dynamicHoverFill,
        hoverTextColor: dynamicHoverTextColor,
        bgColor: dynamicBgColor,
        disable,
        Icon,
    } = dynamicProps ?? {};
    if (disable || !Icon) return null;
    const label = dynamicLabel || column?.label || '';
    const textColor = dynamicTextColor || column?.styles?.textColor;
    const hoverBackgroundColor = dynamicHoverBgColor || column?.styles?.hoverBackgroundColor;
    const fill = dynamicIconFill || '#6021B3';
    const hoverFill = dynamicHoverFill || fill;
    const hoverTextColor = dynamicHoverTextColor || textColor;
    const bgColor = dynamicBgColor || 'transparent';

    return (
        <div
            className={styles.ModalActionContainer}
            onClick={(e) => {
                e.stopPropagation();
                handleModalActionClick?.(row, column?.field);
            }}
            style={
                {
                    '--hover-bg': hoverBackgroundColor,
                    '--hover-fill': hoverFill,
                    '--hover-text-color': hoverTextColor,
                    '--bg-color': bgColor,
                } as React.CSSProperties
            }
        >
            <div className={styles.ModalActionIcon}>
                <Icon width={14} height={14} fill={fill} />
            </div>
            <div className={styles.ModalActionText} style={textColor ? { color: textColor } : undefined}>
                {label}
            </div>
        </div>
    );
};
